export const enableBodyScrolling = () => {
  document.body.setAttribute('style', '')
}

export const disableBodyScrolling = () => {
  document.body.setAttribute('style', 'overflow: hidden; position: fixed; width: 100vw')
}
